import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { teamInitialState } from "./states";
import axios from "axios";

const initialState = teamInitialState;

export const fetchTeamsAsync = createAsyncThunk(
  "teams/Async",
  async (input, thunkApi) => {
    const { successCallback, errorCallback } = input;
    const { getState, rejectWithValue } = thunkApi;
    const { admin, teams } = getState();

    const config = {
      headers: {
        authorization: `Bearer ${admin.accessToken}`
      }
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_END_POINT}admin/getTeams?index=${teams?.index}&limit=${teams?.limit}&search=${teams?.search}&activated=${teams?.filters.approved}&verified=${teams?.filters.verified}&reported=${teams?.filters.reported}`,
        config
      );
      if (successCallback && typeof successCallback === "function") {
        successCallback();
      }
      return {
        teams: response.data.content,
        totalCount: response.data.totalTeams
      };
    } catch (error) {
      errorCallback(error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const TeamsSlice = createSlice({
  name: "teams",
  initialState,
  reducers: {
    verified: (state, action) => {
      const { id, newData } = action.payload;
      const index = state.value.findIndex((bizz) => bizz._id === id);
      if (index !== -1) {
        state.value[index] = {
          ...state.value[index],
          ...newData
        };
      }
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setIndex: (state, action) => {
      state.index = action.payload;
    },
    setVerified: (state, action) => {
      state.filters.verified = action.payload;
    },
    setApproved: (state, action) => {
      state.filters.approved = action.payload;
    },
    setReported: (state, action) => {
      state.filters.reported = action.payload;
    },
    setSearchText: (state, action) => {
      state.search = action.payload;
    },
    clearFilter: (state) => {
      state.index = 0;
      state.filters.approved = null;
      state.filters.verified = null;
      state.filters.reported = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTeamsAsync.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchTeamsAsync.fulfilled, (state, action) => {
      state.isLoading = false;
      state.value = action.payload.teams;
      state.totalCount = action.payload.totalCount;
    });
    builder.addCase(fetchTeamsAsync.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  }
});

export default TeamsSlice.reducer;
export const {
  verified,
  setIndex,
  setLimit,
  setApproved,
  setVerified,
  clearFilter,
  setReported,
  setSearchText
} = TeamsSlice.actions;
